import {useEffect, useState} from "react";
import {Switch, TableCell, TableRow, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Snackbar} from "@mui/material";
import {BiArchiveIn, BiArchiveOut} from "react-icons/bi";
import * as React from "react";
import StaffVetsLandingInsert from "./StaffVetsLandingInsert";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffVetsShowTableRow({
                                                  idx,
                                                  row,
                                                  data,
                                                  setData,
                                                  updateVets,
                                                  openForm,
                                                  isOpenNew,
                                                  setIsOpenNew,
                                                  setLoading
                                              }) {

    // const row = {...row, address: row.formatted_address};
    const [capacity, setCapacity] = useState([]);
    const [changeNzcar, setChangeNzcar] = useState(false);
    const [nzcar, setNzcar] = useState('');
    const [openAgreementDialog, setOpenAgreementDialog] = useState(false);
    const [agreementEmail, setAgreementEmail] = useState(row.email || '');
    const [sending, setSending] = useState(false);
    const [snack, setSnack] = useState({open:false, message:'', severity:'success'});

    useEffect(() => {

        setNzcar(row.nzcar_id);
        try {
            let d = JSON.parse(row.capacity);
            setCapacity(d.filter(({selected}) => selected > 0));
        } catch (e) {
            setCapacity([]);
        }

        setAgreementEmail(row.email || '');

    }, []);

    return (
        <TableRow key={idx}>
            <TableCell sx={{width: '50px'}} align="center">
                <Switch checked={(row.active > 0)}
                        onChange={(e) => updateVets('active', e.target.checked, row.id)}/>
            </TableCell>
            <TableCell align="left" sx={{whiteSpace: 'nowrap'}}>
                {row.business_name}
                <div><a href={""} onClick={(e) => openForm(e, row.id)}>Edit</a></div>
                {
                    (row.password === '' || !row.password) ?
                        <div><strong style={{color: 'red'}}>No password set</strong></div> : ""
                }
            </TableCell>
            <TableCell align="left">{row.merco_id}</TableCell>
            <TableCell align="left">
                <StaffVetsLandingInsert isOpenNew={isOpenNew}
                                        setIsOpenNew={setIsOpenNew}
                                        openForm={openForm}
                                        key={idx}
                                        idx={idx}
                                        row={row}
                                        data={data}
                                        setData={setData}
                                        setLoading={setLoading} />
            </TableCell>
            <TableCell
                align="left">
                Email: {(row.email === null) ? "n/a" : row.email}<br/>
                Accounts email: {(row.email_accounts === null) ? "n/a" : row.email_accounts}<br/>
                Phone: {(row.phone === null) ? "n/a" : row.phone}<br/>
                Username: {(row.username === null) ? "n/a" : row.username}<br/>
                {(row.supplier_website === null) ? "n/a" : <><br/>Web: {row.supplier_website}</>}
            </TableCell>
            <TableCell align="left">
                {
                    capacity.map((cap, index) => {
                        return (
                            <div key = {index} style={{
                                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                                padding: 20
                            }}>
                                <h5>{cap.label}</h5>
                                <strong>Min. weight:&nbsp;</strong>{cap.minimum_weight}, <strong>Min.
                                age:&nbsp;</strong>{cap.minimum_age}<br/>
                                <strong>Capacity spay:&nbsp;</strong>{cap.day_capacity_spay}<br/>
                                <strong>Capacity neuter:&nbsp;</strong>{cap.day_capacity_neuter}<br/>
                            </div>
                        )
                    })
                }
                {
                    (capacity.length === 0) ? "No capacity information available." : undefined
                }
                <div>
                    Capacity (internal): {(row.capacity_internal) ? row.capacity_internal : 'n/a'}
                </div>
            </TableCell>
            <TableCell align="left">
                <div><strong>Public:</strong></div>
                <div style={{whiteSpace: 'pre-line'}}>{row.supplier_terms}</div>
                <div><strong>Community:</strong></div>
                <div style={{whiteSpace: 'pre-line'}}>{row.supplier_terms_community}</div>
            </TableCell>
            <TableCell align="center">
                <Button variant="outlined" size="small" onClick={() => setOpenAgreementDialog(true)}>Send</Button>

                <Dialog open={openAgreementDialog} onClose={() => setOpenAgreementDialog(false)}>
                    <DialogTitle>Send Agreement</DialogTitle>
                    <DialogContent>
                        <div style={{marginBottom:10}}>Send the latest stored agreement to the email address below.</div>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Email"
                            type="email"
                            fullWidth
                            variant="standard"
                            value={agreementEmail}
                            onChange={(e) => setAgreementEmail(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenAgreementDialog(false)}>Cancel</Button>
                        <Button onClick={async () => {
                            setSending(true);
                            try {
                                const res = await FunctionsData.postDataReturn(`/api/vet/${row.id}/bcti/email`, {email: agreementEmail});
                                if (!res) {
                                    setSnack({open:true, message:'Failed to send agreement (no agreement or server error).', severity:'error'});
                                } else {
                                    setSnack({open:true, message:'Agreement sent successfully.', severity:'success'});
                                    setOpenAgreementDialog(false);
                                }
                            } catch (e) {
                                console.error(e);
                                setSnack({open:true, message:'Error sending agreement.', severity:'error'});
                            }
                            setSending(false);
                        }} disabled={sending}>Send</Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    open={snack.open}
                    autoHideDuration={4000}
                    onClose={() => setSnack({...snack, open:false})}
                    message={snack.message}
                />
            </TableCell>
            <TableCell align="center">
                {(row.archived > 0) ?
                    <a href={""}
                       onClick={(e) => {
                           e.preventDefault();
                           updateVets('archived', 0, row.id);
                       }}>
                        <BiArchiveOut size={30}/>
                    </a>
                    :
                    <a href={""}
                       onClick={(e) => {
                           e.preventDefault();
                           updateVets('archived', 1, row.id);
                       }}>
                        <BiArchiveIn size={30}/>
                    </a>
                }
            </TableCell>

        </TableRow>
    )
}
